module.exports = __webpack_public_path__ + "static/media/comment-send-icon.e120d09a.svg";